<template>
  <div>
    <!-- <select class="form-select mf_bg form-select-sm">
      <option disabled selected value="null">{{ title }}</option>
      <option
        v-for="asset_class in content"
        :key="asset_class.id"
        :value="asset_class"
      >
        {{ asset_class[property] }}
      </option>
    </select> -->
    <div class="mf_select_custom">
      <select>
        <option value="null">{{ title }}</option>
        <option
          v-for="asset_class in content"
          :key="asset_class.id"
          :value="asset_class"
        >
          {{ asset_class.name_french }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "content", "property"],
  data() {
    return {
      items: [],
      prop: ""
    };
  },
  mounted() {
    // INITIALISATION DU SELECT
    console.log(this.content);
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("mf_select_custom");
    l = x.length;
    console.log('x',x);
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      console.log(selElmnt);
      ll = selElmnt.length;
      console.log(ll);
      a = document.createElement("DIV");
      a.setAttribute("class", "mf_select-selected");
      console.log("aaaa", selElmnt.options);
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      b = document.createElement("DIV");
      b.setAttribute("class", "mf_select-items select-hide");
      for (j = 1; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function() {
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }
    function closeAllSelect(elmnt) {
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName("mf_select-items");
      y = document.getElementsByClassName("mf_select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    document.addEventListener("click", closeAllSelect);
  }
};
</script>
<style lang="scss">
@import "../../../../../../resources/sass/_variables.scss";

/*the container must be positioned relative:*/
.mf_select_custom {
  position: relative;
  font-family: Arial;
}

.mf_select_custom select {
  display: none; /*hide original SELECT element:*/
}

.mf_select-selected {
  background-color: $bg_color;
  border-radius: 30px;
  box-shadow: $boxShadow;
}

/*style the arrow inside the select element:*/
.mf_select-selected:after {
  position: absolute;
  content: "";
  top: 20px;
  right: 25px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: $mf_ft_color_lt transparent transparent transparent;
}

/*point the arrow upwards when the select box is open (active):*/
.mf_select-selected.select-arrow-active:after {
  border-color: transparent transparent $mf_ft_color_lt transparent;
  top: 12px;
}

/*style the items (options), including the selected item:*/
.mf_select-items div,
.mf_select-selected {
  color: $mf_ft_color_lt;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
  user-select: none;
}

/*style items (options):*/
.mf_select-items {
  position: absolute;
  background-color: $bg_color;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  border-radius: 15px;
  margin-top: 10px;

  div {
    color: $mf_ft_color_lt;
  }
}

/*hide the items when the select box is closed:*/
.select-hide {
  display: none;
}

.mf_select-items div:hover,
.same-as-selected {
  background-color: rgba(0, 0, 0, 0.1);
}

.select-items div:hover {
  &:first-child {
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }
  &:last-child {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>